import { Ban } from "lucide-react";
import { useLang } from "../lib/i18n";
import STATEMENT from "../lib/statement.json";

// Permanent compliance strip (not dismissible). Text single-sourced in lib/statement.json.
export function NoBetsStrip() {
  const { lang } = useLang();
  return (
    <div role="note" data-testid="home-no-bets-strip" className="bg-[#000] border-y border-[rgba(229,184,66,0.35)]">
      <div className="mx-auto max-w-[1880px] px-5 sm:px-8 py-2.5 flex items-start sm:items-center justify-center gap-2.5">
        <Ban className="w-3.5 h-3.5 text-[#E5B842] shrink-0 mt-0.5 sm:mt-0" aria-hidden="true" />
        <p data-testid="home-no-bets-text" className="font-sans font-semibold text-[10px] sm:text-[11px] leading-relaxed uppercase tracking-[0.08em] text-[#E5B842]/90 text-left sm:text-center">
          {STATEMENT[lang]}
        </p>
      </div>
    </div>
  );
}
